"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GatesCache = _interopRequireDefault(require("../utils/GatesCache"));

var _default = function _default() {
  var gatesToMatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (_ref) {
    var gates = _ref.gates;
    var gatesMap = (0, _GatesCache.default)(gates);
    return gatesToMatch.some(function (gate) {
      return gate in gatesMap;
    });
  };
};

exports.default = _default;
module.exports = exports.default;